"use client";

import { setClientAuthMode, setClientSessionTerminatedHandler } from "@dc/gateway-jsonapi";
import { useContext } from "react";
import { AuthBackendContext } from "@/app/providers/AuthBackendModeProvider/AuthBackendContext";
import { amplifyAuthBackend } from "./amplify/index";
import { terminateSession } from "./terminateSession";
import { trimbleAuthBackend } from "./trimble/index";
import type { AuthBackend, AuthBackendId } from "./types";

// Module-level singleton — set by AuthBackendModeProvider on mount so that
// non-React callers (apiClient.ts, etc.) can read it without a hook.
let _resolvedBackend: AuthBackend = trimbleAuthBackend;
export function setResolvedBackend(id: AuthBackendId): void {
  _resolvedBackend = id === "trimble" ? trimbleAuthBackend : amplifyAuthBackend;
  setClientAuthMode(id);
  setClientSessionTerminatedHandler(({
    loginUrl
  }) => {
    void terminateSession(_resolvedBackend, loginUrl);
  });
}

/** For non-React callers: returns the cached backend instance. */
export function getAuthBackend(): AuthBackend {
  return _resolvedBackend;
}

/** For React components: reads from the context set by AuthBackendModeProvider. */
export function useAuthBackend() {
  const id = useContext(AuthBackendContext);
  return id === "trimble" ? trimbleAuthBackend : amplifyAuthBackend;
}